import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class ImportSystemObjectService {
    constructor(private fiBackend: FiBackendService) {}

    ProcessImportSystemObject(files: File[], importSystemObject) {
        const fd = new FormData();

        let counter = 1;
        files.forEach((file) => {
            fd.append('File' + counter, file);
            counter++;
        });

        fd.append('importSystemObject', JSON.stringify(importSystemObject));

        return this.fiBackend.fetchDataPost('Custom/ImportSystemObject/ProcessImportSystemObject', fd);
    }
}
